import { Interval, Note, Scale } from 'tonal';
import { chromaOf } from './fretboard';
import { keySignature, majorKey, type ScaleDegree } from './harmony';

/**
 * Major-scale construction, degrees and key spelling (topic C4). Spelling is
 * strict: every key uses each letter A–G exactly once, so F# major has E#, not
 * F, and "the 6th of Eb" is C. Drills that grade spelling use
 * `compareSpelling` so an enharmonic answer can be explained rather than just
 * marked wrong.
 */

                                                                           

/** The whole/half-step recipe of the major scale: W W H W W W H. */
                                                                                             

/** Interval above the tonic for each major-scale degree (index = degree − 1). */
                                                                                                    

/** Functional names, index = degree − 1. */
                                                
          
               
            
                
             
               
                 
  

/**
 * The 15 major keys with a real key signature (0–7 sharps or flats), in
 * circle order from C sharpwards then flatwards. B/Cb, F#/Gb and C#/Db are
 * enharmonic pairs; tonics outside this list (G#, D#, A#, E#, B#, Fb) need
 * double accidentals.
 */
export const MAJOR_KEY_TONICS: readonly string[] = [
  'C',
  'G',
  'D',
  'A',
  'E',
  'B',
  'F#',
  'C#',
  'F',
  'Bb',
  'Eb',
  'Ab',
  'Db',
  'Gb',
  'Cb',
];

/** One spelling per pitch class, as drills usually present keys (no C#, Gb or Cb). */
                                                           
      
       
      
       
      
      
       
      
       
      
       
      
  

/** Chromatic degree labels relative to a root, index = semitones above it. */
                           
      
       
      
       
      
      
       
      
       
      
       
      
           

export type ChromaticDegree = (typeof CHROMATIC_DEGREES)[number];

                                         
                            
                                                                                 
              
 

                                                                      
                                                              
                                                                  
   
 

/** The seven notes of the major scale, tonic first, spelled by letter (via tonal). */
                                                     
                                                    
 

/** True when the key's spelling needs no double sharps or flats. */
                                                             
                                                   
 

/** The note on a degree: `scaleDegreeNote('Eb', 6)` → `C`. */
                                                                        
                       
                                                 
 

/**
 * The degree a note occupies in the major key, or `null` if it isn't in the
 * key. Spelling-strict: in F# major, `E#` is 7 but `F` is `null`.
 */
                                                                               
                               
                                          
                                                 
 

/** Like `degreeOfNote`, but matching by pitch: in F# major, `F` is 7. */
                                                                                
                           
                                                                  
                                                 
 

/** Chromatic degree of any note relative to a root: E over C → `3`, Bb over C → `b7`. */
                                                                              
                                                                     
                                                     
 

                                                    
                       
                                            
 

/** Ordinal label used in prompts: 1st, 2nd, 3rd … 7th. */
                                                       
                       
                                                                                              
 

export interface MajorKeySpelling {
  readonly tonic: string;
  readonly notes: readonly string[];
  /** Sharps (+) or flats (−) in the signature. */
  readonly alteration: number;
  /** The altered notes in signature order, e.g. F# C# or Bb Eb. */
  readonly accidentals: readonly string[];
}

/** Everything needed to spell a major key and explain its signature. */
                                                                   
                           
                                        
          
             
                         
                               
                                 
    
 

/** True when consecutive notes use consecutive letters and no letter repeats. */
                                                                       
                                                       
                                                                                        
                                  
                             
                                                                                                 
     
 

export type SpellingVerdict = 'correct' | 'enharmonic' | 'wrong';

/**
 * Grade a spelled note: same spelling is `correct`, same pitch with another
 * spelling (F for E#) is `enharmonic`, anything else is `wrong`.
 */
                                                                                   
                               
                            
                                         
                                      
                                                        
 

/** Grade a spelled sequence (a key or chord) note by note. */
                                 
                              
                           
                      
                                 
                       
                                                             
     
 
